module.exports = __webpack_public_path__ + "static/media/comment_admin.fe73129e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/comment_admin.svg
// module id = 2401
// module chunks = 0